<template lang="pug">
b-modal(v-model="isBusy" size="xl" centered no-close-on-backdrop no-close-on-esc hide-header hide-footer)
  .loading-msg
    b-spinner.spinner
    br
    span.message.pre-line.align-self-center.mb-4 {{ value }}／{{ max }} {{ message }}
    b-progress.progress(:value="_value" :max="max")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * プログレスつきローディング表示コンポーネント
 *
 * ローディングの表示/非表示を切り替える
 */
@Component
export default class ProgressLoading extends Vue {
  /** プログレス現在値 */
  @Prop({ required: true })
  value!: number;
  /** プログレス最大値 */
  @Prop({ required: true })
  max!: number;
  /** ローディングの表示 */
  @Prop({ required: true })
  isBusy!: boolean;
  /** 表示メッセージ */
  @Prop({ default: "" })
  message!: string;

  /** Propで渡された値は直接templateで参照しないようにするため、getで渡す */
  get _value(): number {
    return this.value;
  }

  /**
   *  vue lifecycle created
   */
  public created(): void {
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";

.loading-msg {
  text-align: center;
  padding: 2rem 0;

  .spinner {
    width: 40px;
    height: 40px;
    margin-right: 12px;
    color: $loading;
  }
  .message {
    font-size: 1.5rem;
    font-weight: bold;
  }
  .progress {
    margin-right: auto;
    margin-left: auto;
    width: 480px;
  }
}
</style>
